module.exports = __webpack_public_path__ + "static/media/comet.3e0ae06a.png";